var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDollar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00abe6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64 8c-30.926 0-56 25.074-56 56 0 30.922 25.074 56 56 56 30.922 0 56-25.078 56-56 0-30.926-25.078-56-56-56zm0 104c-26.469 0-48-21.531-48-48s21.531-48 48-48 48 21.531 48 48-21.531 48-48 48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64 42.285c5.4219 0 9.832 3.7227 9.832 8.2969 0 2.207 1.793 4 4 4s4-1.793 4-4c0-7.7227-5.9258-14.18-13.832-15.848v-4.7344c0-2.207-1.793-4-4-4s-4 1.793-4 4v4.7344c-7.9062 1.668-13.832 8.125-13.832 15.848 0 7.2031 4.2734 13.113 11.16 15.414l10.816 3.5859c3.668 1.2305 5.6875 4.0078 5.6875 7.8281 0 4.5781-4.4102 8.2969-9.832 8.2969s-9.832-3.7227-9.832-8.2969c0-2.207-1.793-4-4-4s-4 1.793-4 4c0 7.7266 5.9258 14.18 13.832 15.852v4.7383c0 2.207 1.793 4 4 4s4-1.793 4-4v-4.7344c7.9062-1.6719 13.832-8.125 13.832-15.852 0-7.2031-4.2695-13.109-11.16-15.414l-10.816-3.5898c-3.668-1.2266-5.6875-4.0078-5.6875-7.8281 0-4.5742 4.4102-8.2969 9.832-8.2969z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDollar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dollar.62b68185b418e0bf859bed081589fdb0.svg";